import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { selectUserState } from "../../selectors/application";
import { pdpIsLoanSelector, pdpLccIdSelector, pdpOutOfStockSelector, pdpSummarySelector, pdpLoanLeadsDataSelector, pdpOrderPreviewSelector, pdpRiskCheckSelector, pdpPlanTypeSelector } from "../../selectors/pdp";
import { setPdpBillingAction, clearPdpLoanLeadsDataAction, setPdpPersonalInfoAction, clearPdpAction } from "../../redux/actions";
import { useHistory } from "react-router-dom";
import useCartData from "../../hooks/useCartData";
import useAddressFunctions from "../../hooks/useAddressFunctions";
import useChangeMarketModal from "../../hooks/useChangeMarketModal";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import SimpleLink from "../../elements/simple-link";
import PdpChangeMarketModal from "../../sections/pdp-change-market-modal";
import PrimaryButton from "../../elements/primary-button";
import PdpCheckoutTemplate from "../../sections/pdp-checkout-template";
import { getElementOffsetY } from "../../utils";

import "./style.scss";
import { checkoutProgressAction, setProgressBarDataAction } from "../../redux/actions/actions";
import { formatProgressBarSteps } from "../../utils/progressBar";
import PdpBillingInfo from "../../sections/pdp-billing-info";
import PdpPersonalInformation from "../../sections/pdp-personal-information";
import useQuery from "../../utils/useQuery";
import { appendQuery } from "../../utils/urlHelper";
import { redirect } from "../../utils/siteUtils";
import { orderTypes, ProductType, siteErrorCodes, PdpSpuType, planType } from "../../utils/lynkco-constants";
import api from "../../utils/api";
import { downloadFile } from "../../utils/dom";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { getUserIdentity, updateUserIdentity } from "../../services/userService";
import { getApiError } from "../../services/siteService";
import CheckoutErrorView from "../../sections/checkout-error-view";
import { useErrorView } from "../../hooks/useErrorView";
import { getProductByOrderPreview } from "../../utils/measurements";
let errorScrollTimeout;

function PdpShippingBilling({ fields, Steps }) {
  const query = useQuery();
  const { lid, lno, relatedOrderNo } = query;
  /*Redux Start*/
  const dispatch = useDispatch();
  const orderPreview = useSelector(pdpOrderPreviewSelector);
  const user = useSelector(selectUserState);
  const pdpSummary = useSelector(pdpSummarySelector);
  const pdpPlanType = useSelector(pdpPlanTypeSelector);
  const pdpIsLoan = useSelector(pdpIsLoanSelector);
  const pdpLccId = useSelector(pdpLccIdSelector);
  const pdpOutOfStock = useSelector(pdpOutOfStockSelector);
  const pdpLoanLeadsData = useSelector(pdpLoanLeadsDataSelector);
  const pdpRiskCheck = useSelector(pdpRiskCheckSelector);

  const clearPdp = () => dispatch(clearPdpAction());
  const setBilling = payload => dispatch(setPdpBillingAction(payload));
  const setPersonalInfo = payload => dispatch(setPdpPersonalInfoAction(payload));
  const updateProgressBar = data => dispatch(checkoutProgressAction(data));
  const setProgressBarData = data => dispatch(setProgressBarDataAction(data));
  const clearPdpLoanLeadsData = () => dispatch(clearPdpLoanLeadsDataAction());
  /*Redux End*/
  const lang = webStorage.get(S_LANG);
  const templateProps = {
    fields,
    className: "start-of-sales-checkout",
    bodyClass: "start-of-sales-body",
    Steps
  };

  const { template, headingType, heading, emailTopBody, countryLabel, m2mPersonalInformation, cashPersonalInformation, billingInfo, changeMarketModal, submitCTA, disclaimer, downloadDocumentCallback, loanDisclaimer, loanHeadingType, loanHeading, loanRedirect } = fields;
  const { pdpLink, deliveryLink } = template.fields || {};
  const { colorScheme, iconName } = submitCTA?.fields || {};
  const { downloadColorScheme, downloadIconName, downloadButtonText } = downloadDocumentCallback?.fields || {};

  const { href: deliveryUrl, text: submitCTAText } = submitCTA?.fields.link.value || {};
  const billingPersonalInfoRef = React.createRef();
  const billingInfoRef = React.createRef();
  const history = useHistory();
  const { cartQtyList } = useCartData();
  const { addressList, addressLoaded, noAddress, marketCountry, loadAddressList, addAddress, updateAddress, removeAddress } = useAddressFunctions(fields);
  const { currentMarket, changeMarketModalProps, changeMarket } = useChangeMarketModal({
    fields: changeMarketModal?.fields,
    cartQtyList,
    openModal: false,
    onSubmitForm(market) {
      clearPdp();
      window.location.href = `${window.location.origin}/${market.language}/${pdpLink.value.href.replace(/^\/\w+-\w+\//gi, "")}`;
    }
  });
  const [showNextButton, setShowNextButton] = useState(false);
  const [loanHandling, setLoanHandling] = useState(false);
  const [needUpdatePhone, setNeedUpdatePhone] = useState(false);
  const [userIdentity, setUserIdentity] = useState(null);
  const emailHtml = useMemo(() => user?.email && `<span>${emailTopBody?.value || ""} <a href="#">${user?.email}</a></span>`, [user]);
  const marketHtml = useMemo(() => currentMarket && `<div class="label">${countryLabel.value} <span> ${currentMarket.value}</span></div>`, [currentMarket]);
  const isSubmitDisabled = useMemo(() => !userIdentity || !marketCountry || pdpOutOfStock || loanHandling || needUpdatePhone, [userIdentity, marketCountry, pdpOutOfStock, loanHandling, needUpdatePhone]);
  const showLoanDocumentButton = useMemo(() => pdpSummary.SECCI && lang.toLowerCase() === "it-it", [pdpSummary]);
  const personalInformation = useMemo(() => (pdpPlanType === planType.MtM ? m2mPersonalInformation : cashPersonalInformation), [pdpPlanType]);
  const { handleError, errorViewProps } = useErrorView();
  useEffect(() => {
    init();
    createLoanLeads();
  }, []);
  useEffect(() => {
    if (user?.userAccount) {
      loadAddressList();
      if (downloadDocumentCallback?.fields) {
      }
    }
  }, [user]);

  useEffect(() => {
    /** Mesurement */
    if (orderPreview) {
      let dataLayer = window.dataLayer || [];
      let product = getProductByOrderPreview(orderPreview);

      dataLayer.push({
        event: "checkout",
        step: 2,
        checkoutFlow: product?.membershipPlan,
        products: [product]
      });
    }
  }, [orderPreview]);

  const init = async () => {
    const identity = await getUserIdentity();
    setUserIdentity(identity);
  };
  const createLoanLeads = () => {
    if (pdpLoanLeadsData) {
      let body = { ...pdpLoanLeadsData, customerId: user?.customerNumber };
      api.Comparison.create(null, body).then(res => {
        clearPdpLoanLeadsData();
      });
    }
  };
  const saveLoanOrder = async (billingData, personalData) => {
    let loanLink = loanRedirect.value?.href;
    if (loanLink) {
      setLoanHandling(true);
      try {
        const skuQtyVoList = [...pdpSummary.apiBody.skuQtyVoList];
        const { loanTotalAmount, loanMonthlyFee, loanDownPayment, loanFinalpayment: loanFinalPayment, loanInterestRate, loanPaymentMonthPeriod } = pdpSummary?.apiBody?.orderExtraData || {};
        const orderExtraData = {
          loanTotalAmount,
          loanMonthlyFee,
          loanDownPayment,
          loanFinalPayment,
          loanInterestRate,
          loanPaymentMonthPeriod,
          lccId: pdpLccId
        };
        const saveBody = {
          skuQtyVoList,
          subType: orderTypes.buyACarLoan,
          productType: ProductType.vehicle,
          billingAddress: {
            billingAddress1: billingData?.street || "",
            billingAddress2: billingData?.apartment || "",
            billingCity: billingData?.city || "",
            billingCountryCode: marketCountry.regionAbbr,
            billingCountry: marketCountry.regionName,
            billingFirstName: personalData?.firstName || "",
            billingLastName: personalData?.lastName || "",
            billingPhone: personalData?.phone,
            billingPhoneCountryCode: personalData?.phoneArea,
            billingPostalCode: billingData?.postalCode || "",
            billingEmail: user?.email
          },
          contactEmail: user?.email,
          contactMobile: user?.mobileNo,
          contactMobileCountryCode: user?.mobileNoCountryCode,
          bundleId: pdpSummary.apiBody.bundleId,
          orderExtraData
        };
        if (relatedOrderNo) {
          Object.assign(saveBody, {
            relatedOrderNo
          });
        }
        const { obj } = await api.vehicle.order.save(null, saveBody);
        if (!/^http?s:/.test(loanLink)) {
          const { origin } = global.location;
          loanLink = `${origin}${loanLink}`;
        }
        loanLink = appendQuery(loanLink, {
          lid: obj.orderId,
          lno: obj.orderNo
        });
        const { obj: santanderRes } = await api.order.paySantander(null, {
          orderNo: obj.orderNo,
          engine: pdpSummary.engine,
          simulationId: pdpSummary.simulationId,
          redirectionUrl: loanLink,
          lang
        });
        const { redirectUrl } = santanderRes;
        clearPdp();
        redirect(history, redirectUrl, true);
        setLoanHandling(false);
      } catch (ex) {
        console.error(ex);
        await handleError(ex?.code);
        setLoanHandling(false);
      }
    } else {
      await handleError(siteErrorCodes.loanLinkMissing);
    }
  };
  const onSubmit = useCallback(
    async evt => {
      let billingInfoFormData, personalFormData;
      try {
        const billingPersonalInfo = billingPersonalInfoRef.current.validateForm();
        const billingInfo = billingInfoRef.current.validateForm();
        personalFormData = billingPersonalInfo.formData;
        billingInfoFormData = billingInfo ? billingInfo.formData : {};
        let valid = billingPersonalInfo.isValid && billingInfo.isValid;
        if (valid) {
          console.log("updateUserIdentity", personalInformation.fields, userIdentity, personalFormData, billingInfoFormData);
          await updateUserIdentity(personalInformation.fields, userIdentity, personalFormData, billingInfoFormData);
          if (pdpIsLoan && !lid && !lno) {
            await saveLoanOrder(billingInfoFormData, personalFormData);
          } else {
            setBilling(billingInfoFormData);
            setPersonalInfo(personalFormData);
            let nextUrlNew = appendQuery(deliveryUrl, query);

            redirect(history, nextUrlNew, false);
          }
        } else {
          if (errorScrollTimeout) {
            clearTimeout(errorScrollTimeout);
          }
          errorScrollTimeout = setTimeout(() => {
            const errorElement = document.querySelector(".show-warning");
            if (errorElement) {
              window.scrollTo({
                top: getElementOffsetY(errorElement) - 100,
                behavior: "smooth"
              });
            }
          });
        }
      } catch (ex) {
        console.error(ex);
        await handleError(ex?.code);
      }
    },
    [personalInformation, billingPersonalInfoRef, billingInfoRef, pdpIsLoan, pdpRiskCheck]
  );
  const billingPersonalInfoProps = {
    fields: personalInformation?.fields,
    selectVerificationMethodModal: fields?.selectVerificationMethodModal,
    mfaModal: fields?.mfaModal,
    userIdentity,
    visible: true,
    ref: billingPersonalInfoRef,
    checkUpdateRequired({ needUpdate }) {
      setNeedUpdatePhone(needUpdate);
    }
  };

  const billingInfoProps = {
    fields: billingInfo?.fields,
    userIdentity,
    addressList,
    addressLoaded,
    noAddress,
    marketCountry,
    loadAddressList,
    addAddress,
    updateAddress,
    removeAddress,
    visible: true,
    ref: billingInfoRef
  };

  const submitProps = {
    buttonText: submitCTAText,
    colorScheme,
    iconName,
    isDisabled: isSubmitDisabled,
    callback(evt) {
      onSubmit(evt);
    }
  };

  useEffect(() => {
    const { currentStep, _barSteps } = formatProgressBarSteps(fields.template.fields.progressBar.fields.steps);
    setProgressBarData(_barSteps);
    updateProgressBar(currentStep + 1);
    return function cleanUp() {
      setProgressBarData(null);
      updateProgressBar(null);
    };
  }, []);

  const downloadDocumentProps = {
    buttonText: downloadDocumentCallback?.fields.buttonText.value,
    colorScheme: downloadDocumentCallback?.fields.colorScheme,
    iconName: downloadDocumentCallback?.fields.iconName,
    callback(evt) {
      if (pdpSummary.SECCI) {
        downloadFile(pdpSummary.SECCI);
      }
      setShowNextButton(true);
    }
  };
  return (
    <PdpCheckoutTemplate {...templateProps}>
      <section className="car-delivery-shipping-billing">
        <div className="start-of-sales-body">
          <div className="heading">
            <Heading type={headingType} html={heading} typographyClass="type-h2" />
          </div>
          <div className="signed-in-as">
            <BodyText html={emailHtml} className="user-info" />
          </div>
          <PdpPersonalInformation {...billingPersonalInfoProps} />
          <PdpBillingInfo {...billingInfoProps} />
          <div className="info-container">
            <div className="current-country">
              <BodyText html={marketHtml} className="user-info" />
            </div>
            <div className="market-modal">
              <SimpleLink {...changeMarket} />
            </div>
          </div>

          <PdpChangeMarketModal {...changeMarketModalProps} />
          {downloadDocumentCallback && showLoanDocumentButton && (
            <div className="loan-document">
              <BodyText className="disclaimer" html={loanDisclaimer?.value} />
              <PrimaryButton {...downloadDocumentProps} />
            </div>
          )}
          {downloadDocumentCallback && showNextButton && showLoanDocumentButton && (
            <div className="loan-heading">
              <Heading type={loanHeadingType} html={loanHeading} typographyClass="type-h4" />
            </div>
          )}
          {(downloadDocumentCallback === null || showNextButton || !showLoanDocumentButton) && (
            <>
              <PrimaryButton {...submitProps} />
              <BodyText className="disclaimer" html={disclaimer.value} />
            </>
          )}
          <CheckoutErrorView {...errorViewProps} />
        </div>
      </section>
    </PdpCheckoutTemplate>
  );
}
export default withSitecoreContext()(PdpShippingBilling);
